import { useSyncExternalStore } from 'react';

/**
 * حالةُ الجولة المفتوحة — مخزنٌ صغير لا سياق: زرُّ «أعد الجولة» في الترويسة وفي «المزيد» يفتحها،
 * والقشرةُ وحدها ترسمها. `reason` يميّز الفتحَ التلقائي بعد أول دخول (يُحفظ في الخادم عند الإغلاق)
 * من الإعادة اليدوية (تُحفظ أيضاً — فلا تعود تلقائياً بعدها).
 */
type TourState = { open: false } | { open: true; reason: 'auto' | 'manual' };

let state: TourState = { open: false };
const subs = new Set<() => void>();
const emit = () => { for (const s of subs) s(); };

export function startTour(reason: 'auto' | 'manual' = 'manual') { state = { open: true, reason }; emit(); }
export function closeTour() { state = { open: false }; emit(); }

export function useTourState(): TourState {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); return () => { subs.delete(cb); }; },
    () => state,
    () => state,
  );
}
